import script from "./CancelarReservas.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelarReservas.vue?vue&type=script&setup=true&lang=js"

import "./CancelarReservas.vue?vue&type=style&index=0&id=5de2cf84&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de2cf84"]])

export default __exports__